import React, {useState, useEffect, Fragment} from 'react';
import {Prompt} from 'react-router-dom'
import Button from '../Button/Button';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import {Block} from '../../styles/commons';
import Layout from '../Layout/Layout';
import PageTransition from '../PageTransition/PageTransition'
import PageHeader from '../PageHeader/PageHeader';
import RichTextBox from '../TextBoxQuill/TextBoxQuill'
import Portal from '../../stacks/portal/PortalAWS';
import {useErrorToast} from '../../hooks/useErrorToast';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import ModalContainer from '../ConfirmationModal/ConfirmationModalNew'
import DisplaySampleScreen from '../DisplaySampleScreen/DisplaySampleScreen'
import { useMediaQuery } from "../../hooks/useMediaQuery";

const contentThreshold=200
const ContentScreen = props => {

  const {setErrorMsg, errorToast} = useErrorToast('');

  const [loading, setLoading] = useState(false)
  const [loadingMsg, setLoadingMsg] = useState('Loading ...')
  const [value, setValue] = useState('')
  const [isDirty, setIsDirty] = useState(false)
  const [isPublishable, setIsPublishable] = useState(true)
  const [isConfirm, setIsConfirm] = useState(false)
  const [isSample, setIsSample] = useState(false)
  
  const isMobile = useMediaQuery(768);

  // sections: [
  //  {name, content, dirty}
  //]
  useEffect(() => {
    async function get() {
      try {
        const portal = Portal.getInstance()
        setErrorMsg('')
        setLoading(true)
        setLoadingMsg(`Loading content ...`)
        const content = await portal.retrieveContent()
        setValue(content)
        setLoading(false)
      }
      catch (err) {
        if (err.status !== 404) {
          console.log(`INFO Portal content retrieve ${err.message}`)
          setErrorMsg(err.message)
        }
        setLoading(false)
      }
    }
    get()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onChange(newValue, delta, source, editor) {
    setValue(newValue)
    if (source === 'user') {
      setIsDirty(true)
    }
  }

  async function storeContent() {
    try {
        setErrorMsg('')
        setLoading(true)
        setLoadingMsg('Storing content ...')
        const portal = Portal.getInstance()
        await portal.storeContent(value)
        setLoading(false)
        setIsDirty(false)
        setIsPublishable(true)
    }
    catch (err) {
      console.log(`INFO Portal content store ${err.message}`)
      setErrorMsg(err.message)
      setLoading(false)
    }
  }

  async function publishContent() {
    try {
        await storeContent()
        setErrorMsg('')
        setLoading(true)
        setLoadingMsg('Requesting content publication...')
        setIsPublishable(false)
        const portal = Portal.getInstance()
        await portal.publishContent()
        setLoading(false)
        setIsDirty(false)
        setIsPublishable(true)
    }
    catch (err) {
      console.log(`INFO Portal content publish ${err.message}`)
      setErrorMsg(err.message)
      setLoading(false)
    }
  }

  async function launchSample() {
    setIsSample(!isSample)
  }

  async function publish() {
    setIsConfirm(false)
    publishContent()
  }

  return (
    <Fragment>
    <Layout product='portal'>
    <Container>
      <PageHeader title={`DreamEx Connect Content`}/>
      <PageTransition msg={loadingMsg} loading={loading}/>
      <div style={{margin: '20px 70px'}}>
      <a style={{color: 'red', textDecoration: 'underline'}} href='https://youtu.be/bCJqtuVkQjQ' target='_blank' rel='noreferrer'>Please watch this short instructional video to ensure your profile is properly set up.</a>
      </div>
      <p style={{margin: '20px 70px'}}>
        Use the <strong>Save</strong> button to periodically save your work to the cloud for safe keeping.
        Use the <strong>Submit to Review</strong> button when your page is ready for sources of funds to view.
        You will be notified by email if your page is approved and published or if modifications are required.
      </p>
      <div style={{textAlign:'right'}}>
      <Button small disabled={ isDirty === false }  click={() => storeContent()}>Save</Button>
      {!isMobile && <Button small click={launchSample}>{isSample ? `Sample Close` : 'Sample'}</Button>}
      <Button small disabled={ isPublishable === false }  click={() => setIsConfirm(true)}>Submit to Review</Button>
      </div>
      <Block>
        <Row>
          <Col>
            <RichTextBox placeholder='Compose the section here ...'
              {...props}
              value={value}
              onChange={(value, delta, source, editor) => onChange(value, delta, source, editor)}
            />
          </Col>
        </Row>
      </Block>
      <Prompt
        when={isDirty}
        message="You have unsaved work, are you sure you want to leave? Hit OK if you want to leave the page without saving changes."
      />
    </Container>
    {errorToast}
    {isConfirm && value.length >= contentThreshold &&
      <ConfirmationModal
        cancel={() => setIsConfirm(false)}
        confirm={() => publish()}
        confirmationBtnTitle='CONFIRM'
      >
        You are submitting your page for review and publication.
        If the page content is not complete, then hit the CANCEL button and continue composing.
        <p/>
        By hitting CONFIRM you agree that the content of this page is correct.
      </ConfirmationModal>
    }
    {isConfirm && value.length < contentThreshold &&
      <ModalContainer close={() => setIsConfirm(false)}
        buttons={[
          {
            name: 'Dismiss',
            click: () => setIsConfirm(false)
          }
        ]}
      >
        <p>
          Please increase the content of your company page before publishing.
        </p>
        <p/>
      </ModalContainer>
    }



    </Layout>
    {isSample && <DisplaySampleScreen/> }
    </Fragment>
  )
};

export default ContentScreen
